
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registrarse",
      function () {
        return require("private-next-pages/registrarse/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registrarse"])
      });
    }
  